import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Checkbox extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool, //Same as disabled, but not greyed-out
    extraClass: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    title: PropTypes.string,
    renderNullAsFalse: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    readOnly: false,
    value: false,
    text: '',
    extraClass: undefined,
    title: '',
    renderNullAsFalse: false,
  };

  handleClick(e) {
    const { value, disabled, readOnly, onClick } = this.props;
    if (disabled || readOnly) return;

    onClick(!value, e);
  }

  render() {
    const { value, disabled, text, extraClass, title, renderNullAsFalse, readOnly } = this.props;

    return (
      <span
        className={classNames(
          { 'greyed-out': disabled, pointer: !disabled && !readOnly },
          extraClass,
        )}
        title={title}
        onClick={e => this.handleClick(e)}
      >
        <i
          style={{ verticalAlign: 'middle' }}
          className={classNames({
            'fa fa-fw fa-check-square-o': value,
            'fa fa-fw fa-square-o':
              value === false || value === undefined || (value === null && renderNullAsFalse),
            'glyphicon glyphicon-pencil': value === null && !renderNullAsFalse,
            pointer: !disabled && !readOnly,
            disabled,
            'greyed-out': disabled,
            margin5R: text,
          })}
        />
        {text}
      </span>
    );
  }
}
